const humanizeString = require("humanize-string");
const toastr = require("toastr");
import JSONbig from "json-bigint";
import _ from "lodash";
import moment from "moment";
const permissionKey = "frends_permissions";
export class Utilities {
    static getAllUserPermissions() {
        function getCookies() {
            const cookies = {};
            for (const cookie of document.cookie.split("; ")) {
                const [name, value] = cookie.split("=");
                cookies[name] = decodeURIComponent(value);
            }
            return cookies;
        }
        const permissionMap = getCookies()[permissionKey];
        return permissionMap ? JSON.parse(permissionMap) : {};
    }
    static getUserPermission(activity) {
        const allPermissions = this.getAllUserPermissions();
        return allPermissions[activity];
    }
    static humanizeLabel(str) {
        if (str) {
            return capitalizeLastWordIfId(humanizeString(str));
        }
        return str;
    }
    static postJsonAndParseResponse(url, content) {
        return Utilities.fetchBase(url, content, "POST").then(this.parseJsonResponse);
    }
    static putJsonAndParseResponse(url, content) {
        return Utilities.fetchBase(url, content, "PUT").then(this.parseJsonResponse);
    }
    static getFetch(url, queryStringParameters) {
        let fetchUrl = url;
        if (queryStringParameters) {
            const query = Object.keys(queryStringParameters)
                .filter((k) => queryStringParameters[k] != null)
                .map((k) => {
                const key = encodeURIComponent(k);
                const val = queryStringParameters[k];
                if (Array.isArray(val)) {
                    return key + "=" + val.map((v) => encodeURIComponent(v)).join(`&${key}=`);
                }
                else {
                    return key + "=" + encodeURIComponent(val);
                }
            })
                .join("&");
            if (query) {
                fetchUrl = url + "?" + query;
            }
        }
        return fetch(fetchUrl, {
            credentials: "same-origin",
            headers: { "X-Requested-With": "XMLHttpRequest" }
        }).then(Utilities.parseJsonResponse);
    }
    static deleteFetchAndParseResponse(url) {
        return fetch(url, {
            method: "DELETE",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-XSRF-Token": Utilities.getXSRFVerificationToken(),
                "X-Requested-With": "XMLHttpRequest"
            },
            credentials: "same-origin"
        }).then(this.parseJsonResponse);
    }
    static parseJsonResponse(response, customErrorParser) {
        return response.text()
            .then((content) => {
            if (!response.ok) {
                let errorContent;
                try {
                    const errorMsg = JSON.parse(content);
                    if (customErrorParser) {
                        errorContent = customErrorParser(errorMsg);
                    }
                    if (!errorContent) {
                        if (errorMsg["modelState"]) {
                            errorContent = [].concat.apply([], Object.keys(errorMsg["modelState"]).map((key) => errorMsg["modelState"][key])).join("<br/>");
                        }
                        else {
                            errorContent = errorMsg["exceptionMessage"] || errorMsg["message"] || errorMsg;
                        }
                    }
                }
                catch (e) {
                    errorContent = content;
                }
                return Promise.reject(`Error (${response.status}): ${errorContent}`);
            }
            else {
                return Promise.resolve(Utilities.getPossibleJsonFromText(content));
            }
        });
    }
    static getErrorTitle(err) {
        return _.has(err, "message") ? err.message : "Error";
    }
    static getErrorText(err) {
        return _.has(err, "exceptionMessage") ? err.exceptionMessage : err;
    }
    static getStepIdFromParameterKey(loopParameters) {
        if (!loopParameters) {
            return null;
        }
        return loopParameters.map((parameter) => parameter.key + parameter.value).join();
    }
    static getReferencePathFrom$ref($ref) {
        return _.last($ref.split("/"));
    }
    static getLoopParameterDictionary(loopParameters) {
        const ret = {};
        if (!loopParameters) {
            return ret;
        }
        for (const l of loopParameters) {
            ret[l.key] = l.value;
        }
        return ret;
    }
    static toDetailedLocalTime(d) {
        if (d) {
            return moment.utc(d).local().format("YYYY-MM-DD HH:mm:ss");
        }
        else {
            return FRENDS.Localizations.Never;
        }
    }
    static getXSRFVerificationToken() {
        return document.getElementsByName("__RequestVerificationToken")[0].getAttribute("value");
    }
    static navigateTo(path) {
        const base = document.getElementsByTagName("base")[0].href;
        const newProcessUrl = base + path;
        setTimeout(() => window.location.href = newProcessUrl, 1000);
    }
    static toastSuccess(message, title = "", keepOpen = false, showCloseButton = true) {
        toastr.success(message, title, { closeButton: showCloseButton, closeOnHover: false, preventDuplicates: true, timeOut: keepOpen ? 0 : 5000, escapeHtml: true });
    }
    static toastWarning(message, title = FRENDS.Localizations.Warning, keepOpen = false, showCloseButton = false) {
        toastr.warning(message, title, { closeButton: showCloseButton, closeOnHover: false, preventDuplicates: true, timeOut: keepOpen ? 0 : 5000, escapeHtml: true });
    }
    static toastError(message, title = FRENDS.Localizations.Error, keepOpen = true, showCloseButton = true) {
        if (typeof appInsights !== "undefined") {
            appInsights.trackException(message, "Toast", { ["Toast"]: "error" }, null, 2);
        }
        toastr.error(message, title, { closeButton: showCloseButton, closeOnHover: false, preventDuplicates: true, timeOut: keepOpen ? 0 : 5000, escapeHtml: true });
    }
    static fetchBase(url, content, method) {
        return fetch(url, {
            method: method,
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-XSRF-Token": Utilities.getXSRFVerificationToken(),
                "X-Requested-With": "XMLHttpRequest"
            },
            credentials: "same-origin",
            body: content && JSON.stringify(content)
        });
    }
    static arrayToObject(array, keyField, itemField) {
        return array.reduce((obj, item) => {
            obj[item[keyField]] = itemField != null ? item[itemField] : item;
            return obj;
        }, {});
    }
    static getPossibleJsonFromText(text) {
        if (text.length > 0) {
            try {
                return JSONbig.parse(text);
            }
            catch (e) {
                console.debug("Response not valid json: " + text, e);
            }
        }
        return text;
    }
}
function capitalizeLastWordIfId(s) {
    const n = s.split(" ");
    if (n[n.length - 1] === "id") {
        n[n.length - 1] = n[n.length - 1].toUpperCase();
    }
    return n.join(" ");
}
export function isEmptyObject(obj) {
    return Object.getOwnPropertyNames(obj).length === 0;
}
export function printWarning(msg) {
    if (typeof console !== "undefined") {
        console.warn(msg);
    }
}
export function printError(msg) {
    if (typeof console !== "undefined") {
        console.error(msg);
    }
}
export function strEnum(o) {
    return o.reduce((res, key) => {
        res[key] = key;
        return res;
    }, Object.create(null));
}
export function openInNewTabClick(event) {
    if (event.button === 0 && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        event.preventDefault();
        return false;
    }
    return true;
}
